export const getPxByRem = (rem, screenWidth = 375) => {
    if (/(iPhone\sOS)\s([\d_]+)/.test(navigator.userAgent)) {
        return ((document.documentElement.clientWidth * 16) / screenWidth) * rem;
    }
    return ((window.innerWidth * 16) / screenWidth) * rem;
};
